import {useMap} from "react-leaflet";
import {MapFeatures} from "@ui/leafletCustom/types";

export function useLeafletMap(): MapFeatures {
    return useMap()
}